import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import ScreenWrapper from '../ScreenWrapper/ScreenWrapper'
import { useGetOnButtonClick } from './fn/registerUser'
import './ErrorScreen.scss'

// Универсальный экран сообщающий о любых типах ошибок.
function ErrorScreen() {
	const { t } = useTranslation()
	const onButtonClick = useGetOnButtonClick()

	return (
		<ScreenWrapper
			header={t('live.liveEntranceErrorScreenHeader')}
			description="Произошла ошибка, попробуйте войти ещё раз. Наша команда уже работает над этой ошибкой"
			illustration
		>
			<Button
				block
				size="large"
				type="primary"
				onClick={onButtonClick}
				className="live-lesson-error-screen__button"
			>
				{t('live.liveEntranceErrorScreenBtn')}
			</Button>
		</ScreenWrapper>
	)
}

export default ErrorScreen
